import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('entities');
const type = createActionType('entities');

export const DELETE_PROJECT = apiType('DeleteProject');
export const DELETE_VIEW = apiType('DeleteView');
export const DELETE_UNUSED_DATASETS = apiType('DeleteUnusedDatasetsFromProjects');
export const UPDATE_PROJECT_OWNER = apiType('UpdateProjectOwner');
export const UPDATE_PROJECT_NAME = apiType('UpdateProjectName');
export const UPDATE_VIEW_NAME = apiType('UpdateViewName');
export const UPDATE_ENTITY_DESCRIPTION = apiType('UpdateAssetDescription');
export const GET_COLUMN_PROPERTIES = apiType('GetColumnMetaData');

export const OPEN_DELETE_ENTITY_DIALOG = type('OpenDeleteEntityDialog');
export const CLOSE_DELETE_ENTITY_DIALOG = type('CloseDeleteEntityDialog');
